/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useCallback, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core';
import {usePreferencesState} from '@ion/core/src/preferences/hooks/usePreferencesState';
import {GenericObject} from '@ion/core/src/types/entities';
import {Preference} from '@ion/core/src/types/preferences';

export const toggleCollapseStyle = (manual, auto) =>
  ({collapsed}) => collapsed ? manual : auto;
;

// defining the styles definitions...
const useStyles = makeStyles((theme) => ({
  navigationItem : {
    height : toggleCollapseStyle('45px', '60px')
  }
}));

/**
 * Defining the useExpandCollapse hook. This hook is responsible for handling the collapse
 * Expand the navigation and style properties based on the current navigation view.
 * This also handles the persistence of the navigation view in user preferences.
 *
 * ```typescript
 *
 *  import {useExpandCollapse} from '@ion/dls/src/components/navigation/useExpandCollapse';
 *
 *  const {collapsed} = useExpandCollapse();
 *
 * ```
 */
export const useExpandCollapse = (enabled = false, toggleFunc?: Function) => {
  const [collapsed, setCollapsed] = usePreferencesState(Preference.collapsedNavigation, false);
  const classes                   = useStyles({collapsed});

  useEffect(() => {
    toggleFunc?.(null, collapsed);
  }, [collapsed]);

  const onHandleCollapse = useCallback((e, res = !collapsed) => {
    setCollapsed(res, enabled);
  }, [enabled, collapsed]);

  return ({
    classes : enabled ? classes : {} as GenericObject,
    collapsed,
    onHandleCollapse
  });
};

export default useExpandCollapse;
